import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import highlightText from "../../utils/highlightText";
import LabelText from "../../ui/LabelText";
import { useNavigate } from "react-router-dom";
import { useSidebar } from "../../contexts/SidebarContext";
import NoAttribute from "../../assets/icons/NoAttribute.png";
import noImageClub from "../../assets/icons/noImageClub.svg";
import noImagePlayer from "../../assets/icons/noImagePlayer.svg";
import { PlayerAvatar } from "../../styled-components/PlayerCard.Styles";
import { useClubSearch } from "../../contexts/ClubSearchContext";
import { set } from "lodash";
import { usePlayerSearch } from "../../contexts/SearchPlayersContext";

const GlobalSearchItem: React.FC<any> = ({ item, searchText, onRemove, iconType , fromHomePage }) => {
  const navigate = useNavigate();
  const { toggleSidebar, toggleDrawer } = useSidebar();
  const [isHovered, setIsHovered] = useState(false);
  const {setIsClubCompareId , setCompareClubLogoUrl , setCompareClubName} = useClubSearch()
    const {playerSearchOpen , setIsPlayerSearchOpen , comparePlayerImageUrl,comparePlayerName , comparePlayerId ,
      setComparePlayerId , setComparePlayerName , setComparePlayerImageUrl } = usePlayerSearch()


  const handleRemove = () => {
    if (onRemove) onRemove(item);
  };

  let iconComponent;

  switch (iconType) {
    case "remove":
      iconComponent = <CloseIcon className="cta-btn-icons" onClick={handleRemove} />;
      break;
    case "image":
      iconComponent = (
        <>
          {item.imageLogoURL ? (
            <PlayerAvatar
              isClub={item.isTeam}
              className="player-table-image"
              src={item.isTeam ? item.imageLogoURL : undefined}
              backgroundImage={!item.isTeam ? item.imageLogoURL : undefined}
            ></PlayerAvatar>
          ) : (
            <img
              src={item.isTeam ? noImageClub : noImagePlayer}
              alt={item.imageLogoURL ? item.name : "No Image Found"}
              className="player-image"
            />
          )}
        </>
      );
      break;
    default:
      iconComponent = "";
      break;
  }

  const handleViewProfile = () => {
    setIsClubCompareId(0)
    setCompareClubName("");
    setCompareClubLogoUrl("");
    setComparePlayerId(0)
    setComparePlayerName("")
    setComparePlayerImageUrl("")
    const searchedItemFromStorage = localStorage.getItem("searchItem");
    let existingItems = [];
    if (searchedItemFromStorage) {
      existingItems = JSON.parse(searchedItemFromStorage);
    }
    const itemExists = existingItems.some((existingItem: any) => existingItem?.id === item.id);
    if (!itemExists) {
      existingItems.push(item);
      const updatedItemsString = JSON.stringify(existingItems);
      localStorage.setItem("searchItem", updatedItemsString);
    }
    if (item.isTeam) {
      navigate(`/club/${item.id}`);
    } else {
      navigate(`/player/${item.id}`);
    }
    toggleDrawer?.(false);
    if(!fromHomePage){
      toggleSidebar?.(false);
    }
  };

  return (
    <div className="club-item" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <div className="player-text-data" onClick={() => handleViewProfile()}>
        {highlightText(item.name, searchText ? searchText : "")} {/* Use highlightText */}
        <LabelText className="player-team-text">{item.subName}</LabelText>
        {!item.isTeam && !item.isAttributesFound && (
          <div style={{ display: "flex", gap: "8px" }}>
            <img src={NoAttribute} height={16} width={16} />
            <LabelText className="global-search-text">No attribute scores present</LabelText>
          </div>
        )}
      </div>
      {iconComponent}
    </div>
  );
};

export default GlobalSearchItem;
